import * as LucideIcons from "lucide-react";

/**
 * Renderiza um ícone da biblioteca lucide-react dinamicamente com base no nome.
 * Fornece um ícone de fallback (HelpCircle) caso o nome não seja encontrado.
 *
 * @param {object} props
 * @param {string} props.name - O nome do ícone (ex: "Stethoscope", "Pill").
 * @param {object} props.props - Outras props (como size, color) a serem passadas para o ícone.
 */
const DynamicIcon = ({ name, ...props }) => {
  const IconComponent =
    LucideIcons[name] ||
    LucideIcons[name?.charAt(0).toUpperCase() + name?.slice(1)];

  if (!IconComponent) {
    return <LucideIcons.HelpCircle {...props} />;
  }

  return <IconComponent {...props} />;
};

export default DynamicIcon;
